import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { GlobalFunctions } from '../../../core/global-functions';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { AuthService } from '../../../core/auth/auth.service';
import { CommonService } from '../../../core/common.service';
import { CONSTANTS } from '../../../core/constants';
import { LocalStorageHelper } from '../../../core/helpers/local-storage.helper';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, RouterModule, ReactiveFormsModule, ToastModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  providers: [GlobalFunctions, CommonService],
})
export class LoginComponent implements OnInit {
  @ViewChild('logInNgForm') logInNgForm: any;
  logInForm: FormGroup;
  isBtnLoading: boolean = false;
  isPasswordVisible: boolean = false;

  constructor(
    private _formBuilder: FormBuilder,
    private _router: Router,
    private _globalFunctions: GlobalFunctions,
    private messageService: MessageService,
    private _authService: AuthService,
    private _commonService: CommonService,
    private _localStorageHelper: LocalStorageHelper,
  ) {
    this.logInForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this._localStorageHelper.clear();
  }
  validate(): boolean {
    let flag: boolean = true;
    const errorFields: any = [];
    if (!this.logInForm.value.email || this.logInForm.value.email === '') {
      // this._sNotify.error('Email or mobile is required!', 'Oops!');

      errorFields.push('Username');
      flag = false;
      // return false;
    }
    if (
      !this.logInForm.value.password ||
      this.logInForm.value.password === ''
    ) {
      // this._sNotify.error('Password is required!', 'Oops!');
      errorFields.push('Password');
      flag = false;
      // return false;
    }
    if (!flag) {
      let errorString: string = '';
      errorString = errorFields.join(' & ');
      this.messageService.add({ severity: 'error', summary: 'Oops!', detail: errorString + ' must be filled!' });
    }
    return flag;
    // return true;
  }

  logIn(): void {
    if (!this.validate()) {
      return;
    }
    this.isBtnLoading = true;
    const loginPayload: any = {
      email: this.logInForm.value.email.toString(),
      password: this.logInForm.value.password,
    };
    // this.logInForm.disable();
    this._authService.login(loginPayload).subscribe(
      (result: any) => {
        if (result && result.success) {
          if (result.data.email_verified === false) {
            this._localStorageHelper.setItem(
              'userEmail',
              this.logInForm.value.email,
            );
            this._router.navigate(['/verify-otp']);
            this.isBtnLoading = false;
            return;
          }

          this._authService.setRole(result.data.role);
          const isStudent = result.data?.role == 'student' ? true : false;
          this.getProfile(isStudent, result);
        } else {
          // this.logInForm.enable();
          this._globalFunctions.errorHanding(result?.message, this, true);
          this.isBtnLoading = false;
        }
      },
      (error: any) => {
        console.log('error :::', error);
        // this.logInForm.enable();
        // this.logInNgForm.resetForm();
        this._globalFunctions.errorHanding(error, this, true);
        this.isBtnLoading = false;
      },
    );
  }

  getProfile(isStudent: boolean = false, loginUserResponse: any) {
    this.isBtnLoading = true;
    this._commonService.getProfile(isStudent).subscribe({
      next: (result: any) => {
        if (result?.success) {
          this._commonService.setProfileData(result.data);
          this.messageService.add({ severity: 'success', summary: 'Success', detail: loginUserResponse.message });
          this.redirectAfterLogin(isStudent, loginUserResponse.data);
        } else {
          this._globalFunctions.successErrorHandling(result, this, true);
          this.isBtnLoading = false;
        }
      },
      error: (error: any) => {
        this._globalFunctions.errorHanding(error, this, true);
        this.isBtnLoading = false;
      },
    });
  }

  redirectAfterLogin(isStudent: boolean = false, userData: any) {
    if (userData.role == 'student') {
      this._router.navigate(['/find-tutors']);
      this.isBtnLoading = false;
    } else {
      const status = userData.profile_status;
      if (status === 'submitted') {
        this._router.navigate(['/thank-you']);
        this.isBtnLoading = false;
      } else if (status === 'approved') {
        this._router.navigate(['/tutor/dashboard']);
        this.isBtnLoading = false;
      } else if (status === 'pending' || status === 'rejected') {
        this._commonService.getProfileStatus().subscribe({
          next: (result: any) => {
            if (result && result.success && result.data) {
              const steps = result.data;
              const firstIncompleteStep = steps.find(
                (step: any) =>
                  step.status !== 'completed' && step.status !== 'approved',
              );
              if (firstIncompleteStep) {
                this.redirectToStep(firstIncompleteStep.step_key);
              } else {
                this._router.navigate([
                  '/tutor-signup/' + CONSTANTS.tutorSubmitUrl,
                ]);
              }
            } else {
              this._router.navigate([
                '/tutor-signup/' + CONSTANTS.tutorAboutUrl,
              ]);
            }
            this.isBtnLoading = false;
          },
          error: (error: any) => {
            this._router.navigate(['/tutor-signup/' + CONSTANTS.tutorAboutUrl]);
            this.isBtnLoading = false;
          },
        });
      } else {
        this._router.navigate(['/tutor-signup/' + CONSTANTS.tutorAboutUrl]);
        this.isBtnLoading = false;
      }
    }
  }

  redirectToStep(stepKey: string) {
    switch (stepKey) {
      case 'about':
        this._router.navigate(['/tutor-signup/' + CONSTANTS.tutorAboutUrl]);
        break;
      case 'subjects':
        this._router.navigate(['/tutor-signup/' + CONSTANTS.tutorSubjectsUrl]);
        break;
      case 'languages':
        this._router.navigate(['/tutor-signup/' + CONSTANTS.tutorLanguagesUrl]);
        break;
      case 'education':
        this._router.navigate(['/tutor-signup/' + CONSTANTS.tutorEducationUrl]);
        break;
      case 'experience':
        this._router.navigate([
          '/tutor-signup/' + CONSTANTS.tutorExperienceUrl,
        ]);
        break;
      case 'availability':
        this._router.navigate([
          '/tutor-signup/' + CONSTANTS.tutorAvailibilityUrl,
        ]);
        break;
      case 'rate':
        this._router.navigate([
          '/tutor-signup/' + CONSTANTS.tutorRatPerHourUrl,
        ]);
        break;
      case 'submit':
        this._router.navigate(['/tutor-signup/' + CONSTANTS.tutorSubmitUrl]);
        break;
      default:
        this._router.navigate(['/tutor-signup/' + CONSTANTS.tutorAboutUrl]);
        break;
    }
  }
}
